import React from 'react';
import {Button} from 'reactstrap';

const FilterButton = (({ ...props }) => (
    <div className="button-container-filter-pane">
        <Button color={props.filterOptions.filterButtonColor ? props.filterOptions.filterButtonColor : 'primary'} onClick={props.onFilter} ><strong>Filter</strong></Button>
    </div>
));

export default FilterButton;